import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import * as moment from "moment";
import "moment/locale/pt-br";
import TBLDetalheCupom from "../../../components/TBLDetalheCupom";

export default class DetalhesCupom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dias_semana_promocao: [],
    };
  }

  calcularTempoEntrega = (d1, d2) => {
    let dt1 = new Date(d1);
    let dt2 = new Date(d2);
    let diffMs = dt1 - dt2;
    let diffHrs = Math.floor((diffMs % 86400000) / 3600000);
    let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    return diffHrs + " horas e " + diffMins + " minutos";
  };

  formatPreco = (valor) => {
    return parseFloat(valor).toFixed(2).replace(".", ",");
  };
  componentDidMount = () => {
    if (this.props.cupom.tipo === "condominio") {
      let dias_semana_promo = [];
      if (this.props.cupom.condominio.tipo_horario === "livre")
        this.props.cupom.dias.filter((dia) =>
          this.props.cupom.condominio.dias_promocao.includes(dia.value)
            ? dias_semana_promo.push(dia.label)
            : null,
        );
      else
        this.props.cupom.condominio.dias_promocao.map(({ dia_promocao, horarios_dia }) =>
          this.props.cupom.dias.filter((dia) =>
            dia.value === dia_promocao
              ? dias_semana_promo.push({ dia: dia.label, horarios_dia })
              : null,
          ),
        );
      this.setState({
        dias_semana_promocao: dias_semana_promo,
      });
    }
  };
  render() {
    return (
      <div id="detalhes-pedido">
        <Row>
          <Col sm={6}>
            <ul>
              <li>
                <b>ID:</b> {this.props.cupom._id}
              </li>
              <li>
                <b>Código:</b> {this.props.cupom.codigo}
              </li>
              <li>
                <b>Data de Criação:</b> {moment(this.props.cupom?.createdAt).format("l")}{" "}
                {moment(this.props.cupom?.createdAt).format("LT")}
              </li>
              <li>
                <b>Ultima Atualização:</b>{" "}
                {moment(this.props.cupom?.updateStatusAt).format("l")}{" "}
                {moment(this.props.cupom?.updateStatusAt).format("LT")}
              </li>
              <li>
                <b>Atividade:</b> {this.props.cupom.ativo ? "Ativo" : "Inativo"}
              </li>
              {this.props.cupom.tipo_desconto !== "frete_gratis" ? (
                <li>
                  <b>Ativações disponíveis:</b>{" "}
                  {parseInt(
                    this.props.cupom.recurso / this.props.cupom.valor_desconto -
                      this.props.cupom.num_ativacoes_geral *
                        this.props.cupom.valor_desconto,
                  )}
                </li>
              ) : null}

              <li>
                <b>Categoria: </b>
                {this.props.cupom.tipo ? this.props.cupom.tipo : null}
                <br />
              </li>
              <li>
                <b>Desconto: </b>
                {this.props.cupom.tipo_desconto ? this.props.cupom.tipo_desconto : null}
                <br />
              </li>
              <li>
                <b>Descrição: </b>
                {this.props.cupom.descricao ? this.props.cupom.descricao : null}
                <br />
              </li>
            </ul>
          </Col>
          <Col sm={6}>
            <ul>
              <li>
                <b>Valor Total:</b> R${" "}
                {parseFloat(this.props.cupom?.recurso)
                  .toFixed(2)
                  .toString()
                  .replace(",", ".")}
              </li>
              <li>
                <b>Região:</b>{" "}
                {this.props.cupom?.descricao_regiao
                  ? this.props.cupom.descricao_regiao
                  : null}
              </li>
              {this.props.cupom.tipo !== "condominio" ? (
                <li>
                  <b>Data de validade:</b>{" "}
                  {moment(this.props.cupom.expirationDate).format("l")}{" "}
                  {moment(this.props.cupom.expirationDate).format("LT")}
                </li>
              ) : null}

              {this.props.cupom.tipo_desconto !== "frete_gratis" ? (
                <li>
                  <b>Valor do cupom:</b> R${" "}
                  {parseFloat(this.props.cupom.valor_desconto)
                    .toFixed(2)
                    .toString()
                    .replace(",", ".")}
                </li>
              ) : null}

              {/* * Cupom de condominio */}
              {this.props.cupom.tipo === "condominio" ? (
                <div>
                  <li>
                    <b>Dados de condomínio:</b>{" "}
                    <ul>
                      <li>
                        {" "}
                        <b>Nome: </b>
                        {this.props.cupom.condominio.nome_condominio}
                      </li>
                      <li>
                        <b>Endereço: </b>
                        {this.props.cupom.condominio.endereco}
                      </li>
                    </ul>
                  </li>
                  <li>
                    <b>Tipo de horário: </b>
                    {this.props.cupom.condominio.tipo_horario}
                  </li>
                  <li>
                    <b>Dias de promoção: </b>
                    {this.state.dias_semana_promocao.map((day, index) => {
                      let day_text = "";
                      if (this.props.cupom.condominio.tipo_horario === "livre") {
                        day_text = `${day} ${
                          this.state.dias_semana_promocao.length - 1 !== index ? ", " : ""
                        }`;
                      } else {
                        const { dia, horarios_dia } = day;
                        day_text = `${dia} (${horarios_dia.map((h_d) => h_d)})${
                          this.state.dias_semana_promocao.length - 1 !== index ? ", " : ""
                        }`;
                      }
                      return day_text;
                    })}
                  </li>
                </div>
              ) : null}
            </ul>
          </Col>
        </Row>
        <h4>Detalhes do Cupom:</h4>
        <TBLDetalheCupom
          data={this.props.cupom.estabelecimentos}
          cupom={this.props.cupom}
          context={"detalhes_cupom"}
        ></TBLDetalheCupom>
      </div>
    );
  }
}
